class Presets {
  constructor() {
    this.names = {
      DEEPHOUSE: "deepHouse",
      EIGHTBIT: "eightBit",
      PUFFS: "puffs",
      TRAP: "trap",
      VAPORWAVE: "vaporWave"
    };

    Object.freeze(this.names);
    this.masterEffects = {
      bass: {
        effects: [
          {
            effectType: "Filter",
            settings: {
              frequency: 450,
              startFrequency: 20000,
              type: "lowpass"
            }
          },
          {
            effectType: "Convolver",
            settings: {
              wet: -12,
              sendName: "convolverMaster"
            }
          },
          {
            effectType: "PingPongDelay",
            settings: {
              wet: -12,
              sendName: "pingPongMaster"
            }
          }
        ]
      },
      drums: {
        effects: [
          {
            effectType: "Filter",
            settings: {
              frequency: 450,
              startFrequency: 20000,
              type: "lowpass"
            }
          },
          {
            effectType: "Convolver",
            settings: {
              wet: -15,
              sendName: "convolverMaster"
            }
          },
          {
            effectType: "PingPongDelay",
            settings: {
              wet: -12,
              sendName: "pingPongMaster"
            }
          }
        ]
      },
      lead: {
        effects: [
          {
            effectType: "Filter",
            settings: {
              frequency: 450,
              startFrequency: 20000,
              type: "lowpass"
            }
          },
          {
            effectType: "Convolver",
            settings: {
              wet: -4,
              sendName: "convolverMaster"
            }
          },
          {
            effectType: "PingPongDelay",
            settings: {
              wet: -5,
              sendName: "pingPongMaster"
            }
          }
        ]
      }
    }
    this.allPresets = {
      deepHouse: {
        bass: {
          presetName: "Deep House Bass 1",
          instanceType: "MonoSynth",
          isPoly: false,
          octave: -3,
          trackVolume: 3,
          instanceSettings: {
            filter: {
              rolloff: -12,
              Q: 1,
              type: "lowpass",
              detune: 0,
              gain: 0,
              frequency: 350
            },

            oscillator: {
              count: 3,
              frequency: 440,
              detune: 0,
              partialCount: 0,
              modulationFrequency: 0.4,
              harmonicity: 1,
              spread: 20,
              width: 0.2,
              partials: [],
              phase: 0,
              modulationIndex: 2,
              type: "amsquare",
              modulationType: "square"
            },
            envelope: {
              releaseCurve: "exponential",
              release: 0.359,
              decay: 0.206,
              attackCurve: "linear",
              sustain: 0.16,
              attack: 0.001,
              decayCurve: "exponential"
            },
            portamento: 0,
            volume: 0,
            filterEnvelope: {
              decay: 0.61,
              baseFrequency: 243,
              release: 0.001,
              decayCurve: "exponential",
              sustain: 0.001,
              exponent: 2,
              octaves: 3,
              attackCurve: "linear",
              releaseCurve: "exponential",
              attack: 0.001
            },
            detune: 0
          }
        },
        lead: {
          presetName: "chicago2",
          instanceType: "MonoSynth",
          isPoly: false,
          octave: 0,
          trackVolume: 1.5,
          effects: [
            {
              effectType: "Convolver",
              settings: {
                wet: 7
              }
            }
          ],
          instanceSettings: {
            volume: 0,
            filter: {
              gain: 0,
              Q: 1,
              frequency: 350,
              type: "lowpass",
              detune: 0,
              rolloff: -12
            },
            presetName: "Deephouse Lead",
            presetType: "lead",
            detune: 0,
            oscillator: {
              detune: 0,
              partialCount: 0,
              modulationType: "square",
              width: 0.2,
              partials: [],
              phase: 0,
              count: 3,
              modulationFrequency: 0.4,
              harmonicity: 1,
              modulationIndex: 2,
              spread: 20,
              type: "fatsquare",
              frequency: 440
            },
            filterEnvelope: {
              decay: 0.2,
              releaseCurve: "exponential",
              decayCurve: "exponential",
              baseFrequency: 341,
              attackCurve: "linear",
              release: 1.2,
              sustain: 0.4,
              octaves: 3,
              exponent: 2,
              attack: 0.001
            },
            name: "PolySynth",
            portamento: 0,
            envelope: {
              decay: 0.2,
              attack: 0.001,
              decayCurve: "exponential",
              release: 0.165,
              attackCurve: "linear",
              sustain: 0.192,
              releaseCurve: "exponential"
            },
            id: "8FqCLO1oAZVE8KZZCtAb"
          }
        },
        drums: {
          presetName: "deepHouse drums",
          instanceType: "Sampler",
          trackVolume: 3.5,
          samples: {
            urls: {
              C3: "1_r1.wav",
              "C#3": "2_r1.wav",
              D3: "3_r1.wav",
              "D#3": "4_r1.wav"
            },
            baseUrl: "deephouse/"
          },
          instanceSettings: {
            envelope: {
              decayCurve: "exponential",
              release: 0.13,
              decay: 0.197,
              releaseCurve: "exponential",
              attackCurve: "linear",
              sustain: 0.869,
              attack: 0.001
            }
          }
        }
      },
      eightBit: {
        bass: {
          presetName: "8bit bass",
          instanceType: "MonoSynth",
          isPoly: false,
          octave: -2,
          trackVolume: 0.2,
          instanceSettings: {
            detune: 0,
            filterEnvelope: {
              baseFrequency: 8000,
              exponent: 2,
              decayCurve: "exponential",
              decay: 0.2,
              sustain: 0.4,
              octaves: 3,
              attackCurve: "linear",
              attack: 0.2,
              releaseCurve: "exponential",
              release: 1.2
            },
            envelope: {
              attack: 0.001,
              sustain: 0.869,
              attackCurve: "linear",
              releaseCurve: "exponential",
              release: 0.13,
              decayCurve: "exponential",
              decay: 0.197
            },
            volume: 0,
            portamento: 0,
            name: "PolySynth",
            filter: {
              gain: 0,
              rolloff: -12,
              frequency: 350,
              Q: 1,
              type: "lowpass",
              detune: 0
            },

            oscillator: {
              partials: [],
              count: 3,
              detune: 0,
              partialCount: 0,
              width: 0.2,
              phase: 0,
              modulationIndex: 2,
              spread: 20,
              modulationType: "square",
              frequency: 440,
              harmonicity: 1,
              type: "triangle",
              modulationFrequency: 0.4
            }
          }
        },
        lead: {
          presetName: "8bit_lead",
          instanceType: "MonoSynth",
          isPoly: false,
          octave: 0,
          trackVolume: 0.3,
          effects: [
            {
              effectType: "Convolver",
              settings: {
                file: "warmplate.wav",
                wet: -12
              }
            }
          ],
          instanceSettings: {
            name: "PolySynth",
            filter: {
              type: "lowpass",
              detune: 0,
              gain: 0,
              frequency: 350,
              rolloff: -12,
              Q: 1
            },
            volume: 0,
            filterEnvelope: {
              octaves: 3,
              releaseCurve: "exponential",
              decayCurve: "exponential",
              attackCurve: "linear",
              exponent: 2,
              baseFrequency: 8000,
              release: 0.001,
              attack: 0.2,
              decay: 0.2,
              sustain: 0.4
            },
            presetType: "lead",
            oscillator: {
              modulationFrequency: 0.4,
              spread: 20,
              partials: [],
              modulationIndex: 2,
              harmonicity: 1,
              count: 3,
              type: "amsquare",
              partialCount: 0,
              width: 0.2,
              frequency: 440,
              modulationType: "square",
              phase: 0,
              detune: 0
            },
            portamento: 0,
            detune: 0,
            envelope: {
              releaseCurve: "exponential",
              release: 0.102,
              decayCurve: "exponential",
              decay: 0.2,
              attackCurve: "linear",
              attack: 0.001,
              sustain: 0.4
            }
          }
        },
        drums: {
          presetName: "8bit drums",
          instanceType: "Sampler",
          trackVolume: 3.5,
          samples: {
            urls: {
              C3: "1.wav",
              "C#3": "2.wav",
              D3: "3.wav",
              "D#3": "4_r2.wav"
            },
            baseUrl: "eightBit/"
          },
          instanceSettings: {
            envelope: {
              decayCurve: "exponential",
              release: 0.13,
              decay: 0.197,
              releaseCurve: "exponential",
              attackCurve: "linear",
              sustain: 0.869,
              attack: 0.001
            }
          }
        }
      },
      puffs: {
        bass: {
          presetName: "puffs 2",
          instanceType: "MonoSynth",
          isPoly: false,
          octave: -3,
          trackVolume: 1,
          instanceSettings: {
            volume: 0,
            filterEnvelope: {
              release: 0.067,
              baseFrequency: 1403,
              octaves: 3,
              decayCurve: "exponential",
              sustain: 0.139,
              attackCurve: "linear",
              exponent: 2,
              attack: 0.001,
              releaseCurve: "exponential",
              decay: 0.685
            },
            envelope: {
              attackCurve: "linear",
              decayCurve: "exponential",
              decay: 0.224,
              release: 0.449,
              releaseCurve: "exponential",
              sustain: 0.297,
              attack: 0.001
            },
            oscillator: {
              spread: 20,
              width: 0.2,
              modulationIndex: 2,
              detune: 0,
              harmonicity: 1,
              count: 3,
              frequency: 440,
              partials: [],
              partialCount: 0,
              type: "pwm",
              modulationFrequency: 0.4,
              modulationType: "square",
              phase: 0
            },
            filter: {
              gain: 0,
              type: "lowpass",
              rolloff: -12,
              Q: 1,
              frequency: 350,
              detune: 0
            },

            detune: 0,
            portamento: 0,
            name: "PolySynth"
          }
        },
        lead: {
          presetName: "Puffs-lead",
          instanceType: "DuoSynth",
          isPoly: false,
          octave: 0,
          trackVolume: 0.3,
          effects: [
            {
              effectType: "Convolver",
              settings: {
                wet: 5
              }
            }
          ],
          instanceSettings: {
            portamento: 0,
            envelope: {
              attack: 0.2,
              decay: 0.2,
              sustain: 0.4,
              release: 1.2
            },
            filterEnvelope: {
              attack: 0.2,
              decay: 0.2,
              sustain: 0.4,
              release: 1.2,
              baseFrequency: 300
            },
            oscillator: {
              type: "sine",
              partialCount: 0
            }
          }
        },
        drums: {
          presetName: "puffs drums",
          instanceType: "Sampler",
          trackVolume: 3.5,
          samples: {
            urls: {
              C3: "1_r2.wav",
              "C#3": "2_r2.wav",
              D3: "3_r2.wav",
              "D#3": "4_r2.wav"
            },
            baseUrl: "puffs/"
          },
          instanceSettings: {
            envelope: {
              decayCurve: "exponential",
              release: 0.13,
              decay: 0.197,
              releaseCurve: "exponential",
              attackCurve: "linear",
              sustain: 0.869,
              attack: 0.001
            }
          }
        }
      },
      trap: {
        bass: {
          presetName: "trap-bass", // 808 Bass
          instanceType: "MonoSynth",
          isPoly: false,
          octave: -3,
          trackVolume: 1,
          effects: [
            {
              effectType: "Distortion",
              settings: {
                amount: 0.8
              }
            },
            {
              effectType: "Filter",
              settings: {
                frequency: 450,
                type: "lowpass"
              }
            }
          ],
          instanceSettings: {
            portamento: 0.05,
            envelope: {
              attack: 0.001,
              decay: 0.325,
              sustain: 0.4,
              release: 1.2
            },
            filterEnvelope: {
              attack: 0.001,
              decay: 0.2,
              sustain: 0.4,
              release: 1.2,
              baseFrequency: 300
            },
            oscillator: {
              type: "sine",
              partialCount: 0
            }
          }
        },
        lead: {
          presetName: "808 Lead",
          instanceType: "MonoSynth",
          isPoly: false,
          octave: 2,
          trackVolume: 0.5,
          effects: [
            {
              effectType: "Convolver",
              settings: {
                wet: 5
              }
            }
          ],
          instanceSettings: {
            detune: 0,
            filter: {
              type: "lowpass",
              rolloff: -12,
              frequency: 350,
              detune: 0,
              Q: 1,
              gain: 0
            },
            name: "PolySynth",
            filterEnvelope: {
              attackCurve: "linear",
              releaseCurve: "exponential",
              baseFrequency: 8000,
              octaves: 3,
              release: 1.2,
              sustain: 0.382,
              exponent: 2,
              decay: 0.338,
              decayCurve: "exponential",
              attack: 0.001
            },
            volume: 0,
            presetType: "lead",
            oscillator: {
              partials: [],
              harmonicity: 1,
              count: 3,
              frequency: 440,
              width: 0.2,
              detune: 0,
              modulationFrequency: 0.4,
              spread: 20,
              modulationType: "square",
              phase: 0,
              modulationIndex: 2,
              type: "sine",
              partialCount: 0
            },
            envelope: {
              decay: 0.2,
              sustain: 0.332,
              releaseCurve: "exponential",
              attack: 0.001,
              decayCurve: "exponential",
              release: 0.249,
              attackCurve: "linear"
            },
            portamento: 0.05
          }
        },
        drums: {
          presetName: "trap drums",
          instanceType: "Sampler",
          trackVolume: 3.5,
          samples: {
            urls: {
              C3: "1_r1.wav",
              "C#3": "2.wav",
              D3: "3.wav",
              "D#3": "4.wav"
            },
            baseUrl: "trap/"
          },
          instanceSettings: {
            envelope: {
              decayCurve: "exponential",
              release: 0.13,
              decay: 0.197,
              releaseCurve: "exponential",
              attackCurve: "linear",
              sustain: 0.869,
              attack: 0.001
            }
          }
        }
      },
      vaporWave: {
        bass: {
          presetName: "vaporWave 1",
          instanceType: "MonoSynth",
          isPoly: false,
          octave: -3,
          trackVolume: 1.3,
          effects: [
            {
              effectType: "Distortion",
              settings: {
                amount: 0.4
              }
            }
          ],
          instanceSettings: {
            envelope: {
              sustain: 0.224,
              release: 0.196,
              decay: 0.2,
              decayCurve: "exponential",
              releaseCurve: "exponential",
              attack: 0.001,
              attackCurve: "linear"
            },
            filterEnvelope: {
              baseFrequency: 77,
              attackCurve: "linear",
              octaves: 3,
              release: 0.048,
              exponent: 2,
              releaseCurve: "exponential",
              decayCurve: "exponential",
              decay: 0.2,
              sustain: 0.207,
              attack: 0.001
            },
            name: "PolySynth",
            filter: {
              type: "lowpass",
              frequency: 350,
              Q: 1,
              rolloff: -12,
              detune: 0,
              gain: 0
            },
            portamento: 0,
            volume: 0,
            detune: 0,
            oscillator: {
              detune: 0,
              modulationType: "square",
              modulationFrequency: 0.4,
              modulationIndex: 2,
              frequency: 440,
              phase: 0,
              partialCount: 0,
              partials: [],
              width: 0.2,
              type: "sawtooth",
              count: 3,
              harmonicity: 1,
              spread: 20
            }
          }
        },
        lead: {
          presetName: "vaporWave 2",
          instanceType: "MonoSynth",
          isPoly: false,
          octave: 1,
          trackVolume: 1,
          effects: [
            {
              effectType: "Convolver",
              settings: {
                file: "warmplate.wav",
                wet: 5
              }
            },
            {
              effectType: "Distortion",
              settings: {
                amount: 0.4
              }
            }
          ],
          instanceSettings: {
            name: "PolySynth",
            oscillator: {
              phase: 0,
              frequency: 440,
              partialCount: 0,
              spread: 20,
              count: 3,
              modulationFrequency: 0.4,
              modulationIndex: 2,
              harmonicity: 1,
              type: "fatsquare",
              width: 0.2,
              modulationType: "square",
              partials: [],
              detune: 0
            },
            portamento: 0,
            filterEnvelope: {
              baseFrequency: 300,
              release: 1.2,
              exponent: 2,
              sustain: 0.4,
              attack: 0.01,
              decayCurve: "exponential",
              attackCurve: "linear",
              decay: 0.2,
              octaves: 3,
              releaseCurve: "exponential"
            },
            envelope: {
              decayCurve: "exponential",
              attackCurve: "linear",
              releaseCurve: "exponential",
              attack: 0.01,
              decay: 0.3,
              sustain: 0.4,
              release: 1.2
            },
            presetName: "vaporWave 2",
            filter: {
              Q: 1,
              type: "lowpass",
              frequency: 350,
              gain: 0,
              detune: 0,
              rolloff: -12
            },
            volume: 0,
            detune: 0,
            presetType: "lead",
            id: "I1NTtaqVXfHff9c1YGTT"
          }
        },
        drums: {
          presetName: "vaporWave drums",
          instanceType: "Sampler",
          trackVolume: 4.5,
          samples: {
            urls: {
              C3: "1.wav",
              "C#3": "2.wav",
              D3: "3.wav",
              "D#3": "4_r1.wav"
            },
            baseUrl: "vaporWave/"
          },
          instanceSettings: {
            envelope: {
              decayCurve: "exponential",
              release: 0.5,
              decay: 1,
              releaseCurve: "exponential",
              attackCurve: "linear",
              sustain: 1,
              attack: 0.0000001
            }
          }
        }
      }
    };
  }
}
const instance = new Presets();
Object.freeze(instance);
export default instance;
